<si-about
  [aboutTitle]="'NAV.HELP.ABOUT' | translate"
  [subheading]="[`v${applicationVersion}`]"
  [appName]="fullApplicationTitle"
  [licenseInfo]="licenseInfo"
  [acceptableUsePolicyLink]="{
    title: 'Acceptable Use Policy',
    href: 'https://www.siemens.com/sw-terms/aup'
  }"
  [imprintLink]="{
    title: 'Corporate Information',
    href: 'http://www.siemens.com/corporate-information'
  }"
  [privacyLink]="{
    title: 'Privacy Notice',
    href: 'http://www.siemens.com/privacy-notice'
  }"
  [cookieNoticeLink]="{
    title: 'Cookie Notice',
    href: 'https://www.siemens.com/cookie-notice'
  }"
  [termsLink]="{
    title: 'Terms of Use',
    href: 'http://www.siemens.com/terms-of-use'
  }"
  [copyrightDetails]="{
    startYear: 2023,
    lastUpdateYear: 2025
  }"
/>
